import { Space, Tag, Popover, Image } from 'antd';
import { HtmlText } from '@/components/HtmlText';
import htmlToPlainText from '@/components/HtmlToPlainText';
import { FlattenedRoomData } from './types';
import { DEFAULT_ROOM_IMAGE } from '@/constants/AppConfig';

export const renderTags = (tags: string[] | undefined, color: string, remaining = 0) => {
  if (!tags || tags.length === 0) return null;
  return (
    <Space size={[0, 4]} wrap style={{ maxWidth: '100%' }}>
      {tags.map((tag) => (
        <Tag
          color={color}
          key={tag}
          style={{ marginRight: 0, whiteSpace: 'normal', wordBreak: 'break-word', maxWidth: '100%' }}
        >
          {tag}
        </Tag>
      ))}
      {remaining > 0 && <Tag>+{remaining}</Tag>}
    </Space>
  );
};

export const renderTagsPreviewWithPopover = (tags: string[] | undefined, color: string, showCount: number) => {
  if (!tags || tags.length === 0) return '-';

  const showTags = tags.slice(0, showCount);
  const remaining = tags.length - showCount;

  const content = (
    <div style={{ maxWidth: 300, wordBreak: 'break-word' }}>
      <Space size={[8, 6]} wrap>
        {tags.map((t) => (
          <Tag
            color={color}
            key={t}
            style={{ whiteSpace: 'normal', wordBreak: 'break-word', maxWidth: '100%' }}
          >
            {t}
          </Tag>
        ))}
      </Space>
    </div>
  );

  return (
    <Popover content={content} placement="topLeft" trigger="click">
      <div style={{ cursor: 'help', display: 'flex', gap: 8, flexWrap: 'wrap', maxWidth: '100%', overflow: 'hidden' }}>
        {showTags.map((t) => (
          <Tag
            color={color}
            key={t}
            style={{
              maxWidth: '100%',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              display: 'inline-block',
              verticalAlign: 'middle',
            }}
          >
            {t}
          </Tag>
        ))}
        {remaining > 0 && <Tag>+{remaining}</Tag>}
      </div>
    </Popover>
  );
};

export const renderDescriptionPreview = (html: string) => {
  if (!html) return "-";

  const preview = htmlToPlainText(html);

  return (
    <Popover
      placement="topLeft"
      trigger="click"
      title="Description"
      content={
        <div style={{ maxWidth: 520, maxHeight: 260, overflow: "auto" }}>
          <HtmlText value={html} />
        </div>
      }
    >
      <div
        style={{
          cursor: "help",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          width: "100%",
          display: "block",
        }}
      >
        {preview || "-"}
      </div>
    </Popover>
  );
};

export const renderRoomThumb = (record: FlattenedRoomData, onShowDetail: (room: FlattenedRoomData) => void) => {
  return (
    <div onClick={() => onShowDetail(record)} style={{ cursor: 'pointer' }}>
      <Image
        src={record.cover_image || DEFAULT_ROOM_IMAGE}
        width={60}
        height={40}
        style={{ objectFit: 'cover', borderRadius: 4 }}
        preview={false}
      />
    </div>
  )
}
